// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2XFYL","overflowing":"ReadFullNote_overflowing__1PHxs"};